var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lzMain"},[_c('h3',[_vm._v("凭码自助领证")]),_c('div',{staticClass:"codebox"},[_c('div',{ref:"qrCodeDiv"},[_vm._v("code")])])])}
var staticRenderFns = []

export { render, staticRenderFns }